const PLATFORM_DEFINITIONS_PAGE = '21697895853083';

const getPlatformDefinitionsPath = (hash: string) =>
  `articles/${PLATFORM_DEFINITIONS_PAGE}#${hash}`;

const SUPPORT_URL_PATHS = {
  CLOSED_WON_INFLUENCE: getPlatformDefinitionsPath('h_01HXYZW5XMHT7SVBDB3YG0X029'),
  CLOSED_WON_FIRST_TOUCH_ATTRIBUTION: getPlatformDefinitionsPath('h_01JTH2P0GZ89YA1HSW9B5FP2Z3'),
  CLOSED_WON_LINEAR_ATTRIBUTION: getPlatformDefinitionsPath('h_01JTH2P0GZZ76B4ZVM1V2RCEBR'),
  CREATE_SALESFORCE_AUDIENCE: 'articles/19099326570779',
  CREATE_HUBSPOT_AUDIENCE: 'articles/40761374570267',
  DIRECT_VIEW_THROUGH_REALLOCATION: 'articles/38772321546011',
  FIT_SCORE: getPlatformDefinitionsPath('h_01HXYZVHZYTEZ1HTMG79PCB1DJ'),
  INTEGRATION_SALESFORCE: 'articles/13534333911323',
  INTEGRATION_ADROLL: 'articles/25117186978331',
  INTEGRATION_MICROSOFT: 'articles/25117020593179',
  INTEGRATION_DEMANDBASE: 'articles/30509762129051',
  INTEGRATION_FACEBOOK: 'articles/25117057581211',
  INTEGRATION_G2: 'articles/43197569822747',
  INTEGRATION_GOOGLE: 'articles/25117047557659',
  INTEGRATION_GOOGLE_AD_MANAGER: 'articles/33398145572123',
  INTEGRATION_LINKEDIN: 'articles/22584548336027',
  INTEGRATION_REDDIT: 'articles/25117159512859',
  INTEGRATION_STACK_ADAPT: 'articles/49133161738011',
  INTEGRATION_TIKTOK: 'articles/25117146326427',
  INTEGRATION_X: 'articles/25117153757723',
  OPPORTUNITY_INFLUENCE_WINDOW: getPlatformDefinitionsPath('h_01HXYZW5XMGC80YRAP99619NY3'),
  PIPELINE_FIRST_TOUCH_ATTRIBUTION: getPlatformDefinitionsPath('h_01JTH2P0GZ2WNXSYPGYR98D8RD'),
  PIPELINE_LAST_TOUCH_ATTRIBUTION: getPlatformDefinitionsPath('h_01JTH2P0GZEMHEA678EEC343FE'),
  PIPELINE_LINEAR_ATTRIBUTION: getPlatformDefinitionsPath('h_01JTH2P0GZP0YNRCER2G717M4P'),
  PIPELINE_INFLUENCE: getPlatformDefinitionsPath('h_01HXYZW5XMGC80YRAP99619NY3'),
  PIXEL: 'sections/18811026107803',
  SALESFORCE_OPPORTUNITY_REPORTING: 'articles/27231457541403',
  HUBSPOT_OPPORTUNITY_REPORTING: 'articles', // TODO: add article
  VIEW_THROUGH_VISITS: getPlatformDefinitionsPath('h_01JMN4Z6RD6YRS32REJ7K2YE79'),
  VISIT_EFFICIENCY: getPlatformDefinitionsPath('h_01JMN1RW7132446PXBS6ABA11G'),
  VISITS: getPlatformDefinitionsPath('h_01HXYZW5XM1NZCGJ6WQDTGTA34'),
} as const;

export const C99_SUPPORT_HOME_URL = 'https://support.channel99.com/hc/en-us';

export type SupportURLPathType = keyof typeof SUPPORT_URL_PATHS;

const getSupportURL = (path: SupportURLPathType) => {
  return `${C99_SUPPORT_HOME_URL}/${SUPPORT_URL_PATHS[path]}`;
};

export default getSupportURL;
